import { UserCreatePage } from "~/domain/common";

export function DsmUserCreatePage() {
  return <UserCreatePage />;
}
